/**
 * Vislund: after a successful add-to-cart, send the shopper to checkout.
 * Enabled via theme setting redirect_to_checkout_after_add.
 *
 * Does NOT override openCart (header bag icon still opens the drawer).
 */
(function () {
  function enabled() {
    return window.Theme?.settings?.redirectToCheckoutAfterAdd === true;
  }

  function checkoutUrl() {
    const url = window.Theme?.routes?.checkout_url;
    if (url && typeof url === 'string') return url;
    return '/checkout';
  }

  function goToCheckout() {
    if (window.__vislundGoingToCheckout) return;
    window.__vislundGoingToCheckout = true;
    window.location.assign(checkoutUrl());
  }

  function shouldRedirectFromCartUpdate(event) {
    if (!enabled()) return false;
    const data = event?.detail?.data || {};
    if (data.didError) return false;

    // Only redirect on product add, not cart drawer qty / note / discount updates
    const source = String(data.source || '');
    if (
      source === 'product-form-component' ||
      source === 'product-form' ||
      source.includes('quick-add') ||
      source.includes('product-card')
    ) {
      return true;
    }

    // Some Fabric paths only send itemCount on add from product form
    if (!source && typeof data.itemCount === 'number' && data.itemCount > 0 && data.productId) {
      return true;
    }

    return false;
  }

  document.addEventListener(
    'cart:update',
    function (event) {
      if (shouldRedirectFromCartUpdate(event)) {
        goToCheckout();
      }
    },
    true
  );

  // Platform cart lines event (quick-add / some product cards)
  // Only treat explicit "add" actions as ATC; ignore quantity updates in the drawer.
  function bindPlatformCartAdd() {
    try {
      document.addEventListener(
        'shopify:cart:lines:update',
        function (event) {
          if (!enabled()) return;
          const action = event?.action || event?.detail?.action;
          if (action !== 'add') return;

          // Skip if this looks like a drawer line edit (no product add source)
          const source = String(event?.detail?.source || event?.source || '');
          if (source.includes('cart-items') || source.includes('quantity')) return;

          goToCheckout();
        },
        true
      );
    } catch (e) {
      /* no-op */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindPlatformCartAdd, { once: true });
  } else {
    bindPlatformCartAdd();
  }
})();
